import React from 'react'
import ClaimDetails from './ClaimDetails'
import ClaimCustomizeIframe from "./ClaimCustomizeIframe";

class SubmitClaimWithIdentificationNumber extends React.Component {
  constructor() {
    super()

    this.state = {
      debuggerMode: false
    }
  }

  renderIdentificationNumber(identificationNumber, index) {
    return (
      <li key={index}> { identificationNumber } </li>
    )
  }

  buildJSON(payload) {
    if (JSON.stringify(payload) === JSON.stringify({})) {
      return null
    } else {
      return JSON.stringify(payload, undefined, 2)
    }
  }

  expectedFromUnumList (date) {
    const parsedDate = Date.parse(date)
    const final_date = moment(parsedDate).add(15, 'day').format('dddd, MMMM DD, YYYY')
    return(
      <ul>
        <li>Over the next few days, you will receive additional documentation from Unum regarding your request.</li>
        <li>If you are eligible for Family Medical Leave, you may be required to submit additional medical documentation
        and/or certification in order to support your leave request.</li>
        {
          gon.employee_layout == 'unum_theme' ?
          <li>
            Unum will notify you via email when your eligibility information and next steps are available.
          </li>
          :
          <li>
            You will be mailed a packet containing your eligibility information and any certification and/or documentation
            that may be needed to support your leave request.
          </li>
        }
        <li>If documentation is required, it will be due back to Unum 15 days from today or as specified by Unum.</li>
      </ul>
    )
  }

  renderDebuggerMode() {
    return (
      <div>
        <div className='payload-response'>
          <div className='response-title'>
            Request
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.request) }
          </pre>
        </div>
        <div className='payload-response'>
          <div className='response-title'>
            Response
          </div>
          <pre className='response-detail'>
            { this.buildJSON(this.props.response) }
          </pre>
        </div>
      </div>
    )
  }

  renderClaimRequestBody() {
    const { customizable_screen_content, id, leave_scenario, reported_at } = this.props
    const { claim_with_identification_number } = customizable_screen_content

    if (claim_with_identification_number) {
      return (
        <div>
          <ClaimDetails claimId={id} hasCustomContentNumber={true} />
          <ClaimCustomizeIframe content={claim_with_identification_number} />
        </div>
      )
    }

    const faCheckDivStyle = {
      height: 84,
      minWidth: 96,
      display: 'flex',
      justifyContent: 'center',
      border: '10px solid #8BC758',
      alignItems: 'center',
      borderRadius: 10
    }
    const faCheckStyle = {
      fontSize: 48,
      color: '#8BC758'
    }
    return (
      <div>
        <div className='claim-identification-requested-body'>
          <div className='claim-requested-leave'>
            <div style= { faCheckDivStyle }>
              <i className='fa fa-arrow-up' style={ faCheckStyle }></i>
            </div>
            <div className='submit-claim-circle-check'>
              <p>We have submitted your Request
              for your {leave_scenario} to
              Unum.</p>
              <ClaimDetails claimId={id} />
              <br/>
              <p>If you have any questions, please reach out
              to us through in-App chat.</p>
            </div>
          </div>
          <div className='claim-identification-happens-text'>
            <strong> What happens now? </strong><br/>
            {
              this.props.unumTheme() ?
                <span>
                  <p>Your request is now being reviewed by Unum.
                      You can monitor the status of your request by going to
                    <a href='/app/claims' target='_blank'> Unum's claim portal</a>.</p>
                </span>
                :
                <span>
                  <p>Your request is now being reviewed by Unum.
                      You can monitor the status of your request by going to
                    <a href='https://services.unum.com' target='_blank'> Unum's claim portal </a>
                    or by downloading the app for Android or iOS.</p>
                  <div className='claim-customer-apps col-md-10 col-lg-8'>
                    <a href='https://play.google.com/store/apps/details?id=com.unum.mobile&hl=en_US' target='_blank'>
                      <div className='claim-app-link'>
                        <img src="https://lh3.googleusercontent.com/PIq0mSy6mqGZZ95ybDEdEa3I8G_lkj5G9l7UJRTzUI_3rrM6kxyqhJNe4VLRsJQGNMM=s180-rw" alt="sometext" height='70px' width='70px' />
                        <p>Android</p>
                      </div>
                    </a>
                    <h5> or </h5>
                    <a href='https://itunes.apple.com/us/app/unum-customer/id926425669?mt=8' target='_blank'>
                      <div className='claim-app-link'>
                        <img src="https://lh3.googleusercontent.com/PIq0mSy6mqGZZ95ybDEdEa3I8G_lkj5G9l7UJRTzUI_3rrM6kxyqhJNe4VLRsJQGNMM=s180-rw" alt="sometext" height='70px' width='70px' />
                        <p>iOS</p>
                      </div>
                    </a>
                  </div>
                </span>
            }
          </div>
        </div>
        <div className='expected-from-unum-div'>
          <div className='expected-from-unum-container'>
            <div className='expected-from-unum-header'>
              What can you expect from Unum?
            </div>
            <hr />
            <div className='expected-from-unum-text'>
              { this.expectedFromUnumList(reported_at) }
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderNormalMode() {
    return (
      <div className="submit-claim-identificaion-div col-lg-10">
        <div className='submit-claim-header-text'>
          Your Request has been successfully sent to Unum
        </div>
        {this.renderClaimRequestBody()}
        <div className='back-to-claim-div'>
          { this.props.redirectButton() }
        </div>
      </div>
    )
  }

  renderDebuggerModeSwitch() {
    let switchText = 'Switch to Debugger Mode'
    if (this.state.debuggerMode) {
      switchText = 'Switch to Normal Mode'
    }
    return this.props.is_admin ? (
      <span
        className='submit-view-switch'
        onClick={(e) => this.setState({debuggerMode: !this.state.debuggerMode})}
      >
        { switchText }
      </span>
    ) : null
  }

  renderSection() {
    if (this.state.debuggerMode) {
      return this.renderDebuggerMode()
    } else {
      return this.renderNormalMode()
    }
  }

  render () {
    return (
      <div className='claim-container'>
        <div className='submit-view-buttons'>
          <a
            className='submit-view-switch'
            href={`/claims/${this.props.id}/edit`}
          >
            Edit
          </a>
          { this.renderDebuggerModeSwitch() }
        </div>
        { this.renderSection() }
      </div>
    )
  }
}

export default SubmitClaimWithIdentificationNumber;
